import { ErrorComponent, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "@/utils/query-client";
import { useGymStore } from "./stores/gym-store";

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    gymStore: useGymStore,
  },
  defaultNotFoundComponent: () => <h1>404 Not found</h1>,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  notFoundMode: "root",
  defaultPreload: "intent",
  scrollRestoration: true,
});
